import { Heading, Skeleton, VStack } from "@chakra-ui/react";
import { useEffect, useState } from "react";

import BookingCard from "../components/BookingCard";
import { BookingService } from "../services/booking.service";
import EmptyState from "../components/EmptyState";
import { Helmet } from "react-helmet";
import { IBooking } from "../types/types";
import { PiShieldSlashBold } from "react-icons/pi";
import { useNavigate } from "react-router-dom";

const bookingService = new BookingService();

const Bookings = () => {
  const navigate = useNavigate();

  const [bookings, setBookings] = useState<IBooking[]>();
  const [bookingsLoading, setBookingsLoading] = useState<boolean>(false);

  useEffect(() => {
    getBookings();

    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const getBookings = async () => {
    setBookingsLoading(true);

    const { data } = await bookingService.list();
    console.log("[getBookingData] bookings", data);

    setBookingsLoading(false);
    if (!data || !data.data) return;

    setBookings(data.data);
  };

  return (
    <>
      <Helmet>
        <meta charSet="utf-8" />
        <title>Reservas - SALA</title>
        <link rel="canonical" href={window.location.href} />
      </Helmet>
      <VStack w={"full"} spacing={8} alignItems={"start"} p={4}>
        <Heading as="h1" size="xl">
          Tus últimas reservas
        </Heading>

        {/* Bookings list */}
        <VStack w={"full"} spacing={4} alignItems={"start"}>
          {bookingsLoading || !bookings ? (
            [...Array(3)].map((_, i) => <Skeleton w={"full"} h={20} key={i} />)
          ) : bookings.length === 0 ? (
            <EmptyState
              icon={{
                color: "gray",
                icon: PiShieldSlashBold,
              }}
              title="No tienes ninguna reserva"
              description="Todavía no has hecho ninguna reserva. ¿A qué esperas? ¡Haz una ahora!"
              action={{
                label: "Hacer una reserva",
                onClick: () => {
                  navigate("/booking");
                },
                colorScheme: "brand",
              }}
              bgColor="gray.50"
            />
          ) : (
            bookings
              .sort(
                (a, b) =>
                  new Date(b.start_time).getTime() -
                  new Date(a.start_time).getTime()
              )
              .map((booking) => (
                <BookingCard
                  key={booking.id}
                  booking={booking}
                  onSuccess={() => getBookings()}
                />
              ))
          )}
        </VStack>
      </VStack>
    </>
  );
};

export default Bookings;
